module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "teammate"
    }
  }, [_c('bc-navbar'), _vm._v(" "), (_vm.isLoadedPage && _vm.teammate) ? _c('div', {
    staticClass: "page_maincontent layout_fullwidth_padding"
  }, [_c('a', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px",
      "text-transform": "uppercase"
    }
  }, [_vm._v("\n               " + _vm._s(_vm.teammate.fullName) + "\n            ")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.teammate.title))]), _vm._v(" "), _c('img', {
    staticClass: "teammate-photo",
    attrs: {
      "src": _vm.teammate.photo
    }
  }), _vm._v(" "), (_vm.isButtonShowed && !_vm.customerUser.isDemoUser && _vm.teammate.isCustomerApp) ? _c('div', {
    staticClass: "teammate-btn",
    style: (_vm.borderStyle),
    on: {
      "click": function($event) {
        return _vm.registerCustomerApp(_vm.teammate.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.regButtonText))]) : _vm._e(), _vm._v(" "), (!_vm.isButtonShowed && !_vm.isDBCRegistered) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Registering...")]) : _vm._e(), _vm._v(" "), (!_vm.isButtonShowed && _vm.isDBCRegistered) ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.goToDBC()
      }
    }
  }, [_vm._v("Go to Digital Business Card")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "teammate-bio"
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("BIO")]), _vm._v(" "), _c('div', {
    staticClass: "teammate-bio-content",
    domProps: {
      "innerHTML": _vm._s(_vm.teammate.bio)
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.isLoadedPage) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "top": "50%"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "left": "-50%"
    }
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": _vm.customization.mainColor
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cbe8c03e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbe8c03e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/meet-the-team/teammate.vue
// module id = 867
// module chunks = 0